import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['statementContent', 'tab', 'spinner'];

  connect() {

  }

  activateTabAndShowSpinner(event) {
    this.tabTargets.forEach((tab) => {
      tab.classList.remove('tab-active');
    });

    event.target.classList.add('tab-active');

    this.statementContentTarget.innerHTML = this.spinnerTarget.innerHTML;
  }
}
